import { RequestBuilder } from "../requestBuilder";
import {
  AIProviderKeySchema,
  AIProviderKeysResponseSchema,
  CreateAIProviderKeyInputSchema,
  CredentialIdParamsSchema,
} from "./llmCredentialsClient.types";

export const ListAIProviderKeysRequestConfig = new RequestBuilder({
  path: () => "/integrations/llm",
  responseSchema: AIProviderKeysResponseSchema,
}).withIncludeOrganizationId();

// The backend probes the key against the provider before saving, so a rejected
// key never reaches the list.
export const CreateAIProviderKeyRequestConfig = new RequestBuilder({
  path: () => "/integrations/llm",
  bodySchema: CreateAIProviderKeyInputSchema,
  responseSchema: AIProviderKeySchema,
})
  .withMethod("POST")
  .withIncludeOrganizationId();

// Re-probes a stored key, which is how a rejected one gets back to active
// without being re-entered.
export const VerifyAIProviderKeyRequestConfig = new RequestBuilder({
  paramsSchema: CredentialIdParamsSchema,
  path: ({ credentialId }) => `/integrations/llm/keys/${credentialId}/verify`,
  responseSchema: AIProviderKeySchema,
})
  .withMethod("POST")
  .withIncludeOrganizationId();

// Drops the row and the stored secret. The body is ignored, so no response
// schema.
export const DeleteAIProviderKeyRequestConfig = new RequestBuilder({
  paramsSchema: CredentialIdParamsSchema,
  path: ({ credentialId }) => `/integrations/llm/keys/${credentialId}`,
})
  .withMethod("DELETE")
  .withIncludeOrganizationId();
